import React from 'react';
import {Colors, Sizes} from '../../ts/enums';
import './index.scss';

const ButtonAnimation = (e) => {
    let span = e.target.querySelector('span');
    if (typeof window !== 'undefined' && span) {
        let rect = e.target.getBoundingClientRect();
        let relX = e.pageX - (rect.left + window.scrollX);
        let relY = e.pageY - (rect.top + window.scrollY);
        span.style.left = `${relX}px`;
        span.style.top = `${relY}px`;
    }
}

const Button = (props) => (    
    <span
        data-color={props.color || Colors.RED}
        data-disabled={props.disabled || false}
        data-solid={props.solid || false}
        data-size={props.size || Sizes.MEDIUM}
        className={`spanButton ${props.className}`}
        onMouseOver={ButtonAnimation}
        onMouseOut={ButtonAnimation}
        onClick={props.onClick}
        tabIndex={-1}>
            {props.children || props.text}
            <span className='buttonEffect'></span>
    </span>
)

export {Button};